import UrlPattern from "url-pattern"

export function route(pattern: string, path: string): null | any {
    let urlPattern = new UrlPattern(pattern)
    return urlPattern.match(path)
}
